'use es6';

import Raven from 'raven-js';
export const reportZorseUndefined = (extra = {}) => {
  Raven.captureMessage('hubspot.zorse not defined', {
    level: 'warning',
    extra
  });
};